import { render, staticRenderFns } from "./bimPopup.vue?vue&type=template&id=154d0904&scoped=true&"
import script from "./bimPopup.vue?vue&type=script&lang=js&"
export * from "./bimPopup.vue?vue&type=script&lang=js&"
import style0 from "./bimPopup.vue?vue&type=style&index=0&id=154d0904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154d0904",
  null
  
)

export default component.exports